import sampling_attributes from "assets/img/docs/gettingStarted/remote-sampling/sampling_attributes.png";
import * as React from 'react';
export default {
  sampling_attributes,
  React
};